import type { CSSProperties } from 'react'

export const getInputCursorStyle = ({
  isDisabled,
  isReadOnly,
}: {
  isDisabled?: boolean
  isReadOnly?: boolean
}): CSSProperties['cursor'] => {
  if (isDisabled) return 'not-allowed'
  if (isReadOnly) return 'default'
  return 'pointer'
}
